import { Box, Typography, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { useGetAllOrdersInAllStepsCount } from "./Hoock";

function OrdersInProgress() {
  const theme = useTheme().palette.mode;
  const { data } = useGetAllOrdersInAllStepsCount();
  useEffect(() => {
  }, [data]);

  return (
    <Box
      sx={{
        background: theme === "dark" ? "#262D39" : "#FFF",
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.14)",
        borderRadius: "1rem",
        padding: "1rem",
      }}
    >
      <Typography>آمار سفارشات در حال اجرا</Typography>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography color={"#1E6AFD"} fontSize={"13px"}>
            {" "}
            نام مرحله
          </Typography>
          <Typography color={"#1E6AFD"} fontSize={"13px"}>
            تعداد
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"column"}
          sx={{ marginTop: "8px" }}
        >
          {data?.map((item, i) => {
            return (
              <Box
              key={`prog-${i}`}
                sx={{
                  padding: "8px",
                  background: theme === "dark" ? "rgb(22, 27, 37)" : "#F7FBFF",
                  marginBottom: "6px",
                  borderRadius: "8px",
                }}
                display={"flex"}
                justifyContent={"space-between"}
              >
                <Box display={'flex'} alignItems={'center'}>
                    <i className={item.icon}></i>
                  <Typography fontSize={"13px"}>{item.stepName}</Typography>
                </Box>
                <Typography className="font-num" fontSize={"16px"}>
                  {item.processInStepCount}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}

export default OrdersInProgress;
